import SEOMeta from '@/components/base/SEOMeta';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/base/ScrollToTop';
import Breadcrumb from '@/components/base/Breadcrumb';
import BrandStory from './components/BrandStory';
import Reputation from './components/Reputation';
import ContactSection from './components/ContactSection';
import FAQSection from './components/FAQSection';

export default function AboutPage() {
  const breadcrumbItems = [
    { label: '首页', href: '/' },
    { label: '关于我们' },
  ];

  const faqSchema = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: [
      {
        '@type': 'Question',
        name: '尾巴漫画网上的韩国漫画都是免费的吗？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '是的，尾巴漫画网上的所有韩国漫画均提供在线免费阅读服务。我们致力于为广大韩漫爱好者提供免费、优质的阅读体验，无需付费即可畅享海量韩漫资源。',
        },
      },
      {
        '@type': 'Question',
        name: '网站上的漫画画质如何？有删减吗？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '我们提供的所有韩国漫画均为高清画质，且保证无删减内容。尾巴漫画网坚持原汁原味的内容呈现，让您享受最完整的韩漫阅读体验。',
        },
      },
      {
        '@type': 'Question',
        name: '漫画多久更新一次？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '尾巴漫画网每日更新热门韩漫，月均更新超过3000个章节。热门连载漫画通常保持与韩国同步的更新频率，确保您及时追更。',
        },
      },
      {
        '@type': 'Question',
        name: '如何找到我想看的漫画？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '您可以通过首页的分类导航、搜索功能或排行榜来找到喜欢的韩国漫画。网站提供恋爱、奇幻、动作、悬疑等多种分类，方便您快速浏览。',
        },
      },
      {
        '@type': 'Question',
        name: '支持手机阅读吗？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '当然支持！尾巴漫画网采用响应式设计，完美适配手机、平板和电脑等多种设备。下拉式阅读设计在手机上体验尤为流畅舒适。',
        },
      },
    ],
  };

  const aboutSchema = {
    '@context': 'https://schema.org',
    '@type': 'AboutPage',
    name: '关于尾巴漫画网 - 好看的韩国漫画免费阅读平台',
    description: '尾巴漫画网专注好看的韩国漫画，提供韩漫在线免费阅读。了解我们的品牌故事、读者口碑和联系方式。',
    url: 'https://www.weibamanhua.com/about',
    isPartOf: {
      '@type': 'WebSite',
      name: '尾巴漫画网',
      url: 'https://www.weibamanhua.com',
    },
  };

  return (
    <>
      <SEOMeta
        title="关于我们_尾巴漫画网 - 好看的韩国漫画免费阅读平台"
        description="尾巴漫画网专注好看的韩国漫画，提供韩漫在线免费阅读。了解我们的品牌故事、读者口碑和联系方式，高清无删减韩漫在线免费阅读。"
        keywords="尾巴漫画网,关于尾巴漫画网,韩漫平台,好看的韩国漫画,韩漫在线免费阅读"
        canonicalUrl="https://www.weibamanhua.com/about"
        schema={[aboutSchema, faqSchema]}
      />
      <ScrollToTop />
      <Navbar />

      <main>
        <div className="bg-background-100">
          <div className="max-w-6xl mx-auto px-4 md:px-6 pt-8">
            <Breadcrumb items={breadcrumbItems} />
            <div className="text-center py-12 md:py-16">
              <h1 className="font-heading text-3xl md:text-4xl font-bold text-foreground-900 mb-4">
                关于尾巴漫画网
              </h1>
              <p className="text-base md:text-lg text-foreground-500 max-w-2xl mx-auto leading-relaxed">
                专注好看的韩国漫画，提供韩漫在线免费阅读体验。<br className="hidden md:block" />
                始于热爱，忠于品质，用心做好每一个细节。
              </p>
            </div>
          </div>
        </div>

        <BrandStory />
        <Reputation />
        <FAQSection />
        <ContactSection />
      </main>

      <Footer />
    </>
  );
}